import React from 'react';
import { Result } from 'antd';

function ProtectedRoute({ user, roles, children }) {
  if (roles && !roles.includes(user?.role)) {
    return <Result status="403" title="403" subTitle="Bạn không có quyền truy cập trang này." />;
  }
  return children;
}

export default ProtectedRoute;
